export const analyticsAttributes = {
	proactiveGeneratedAI: 0,
	userGeneratedAI: 1,
	isAIFeature: 1,
	inProductExperience: 'jsmComposer',
};
